@if (constructionSite$ | async) {
  <mat-card appearance="outlined">
    @if ((actionPending$ | async)) {
      <div fxLayout="column" fxFill fxLayoutAlign="center center">
        <mat-spinner></mat-spinner>
      </div>
    }
    @if ((constructionSite$ | async); as constructionSite) {
      <div fxFlex fxLayout="column" fxLayoutAlign="start left">
        <table mat-table [dataSource]="constructionSite.documents" #documentsTable>
          <ng-container matColumnDef="fileName">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let document">{{ document['name'] }}</td>
          </ng-container>
          <ng-container matColumnDef="isVao">
            <th mat-header-cell *matHeaderCellDef>VAO</th>
            <td mat-cell *matCellDef="let document">
              <mat-icon class="material-icons">{{ (document['isVao']) === true ? 'done' : 'clear' }}</mat-icon>
            </td>
          </ng-container>
          <ng-container matColumnDef="url">
            <th mat-header-cell *matHeaderCellDef>Download Link</th>
            <td mat-cell *matCellDef="let document"><a rel="noopener" target="_blank" href="{{ document['url'] }}">download</a></td>
          </ng-container>
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef>{{ 'core.deleteBtn' | translate }}</th>
            <td
              mat-cell
              *matCellDef="let document"
              >
              <mat-icon (click)="deleteDocumentFromConstructionSite(document)" class="delete-action">delete</mat-icon>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        @if (documentsTable.dataSource && documentsTable.dataSource.length == 0 ) {
          <app-no-result-message></app-no-result-message>
        }
      </div>
    }
    <div class="documents-upload" *ngxPermissionsOnly="['ROLE_USER']">
      <div class="upload-btn-wrapper">
        <button mat-raised-button (click)="cancelDefault($event)" color="primary">{{ 'core.documentUpload' | translate }}</button>
        <input type="file" class="mat-button"
          ng2FileSelect [uploader]="uploader" multiple
          [disabled]="actionPending$ | async"
          />
      </div>
      <div class="confirm-btn-wrapper">
        <button type="button" mat-raised-button color="accent" (click)="onConfirm()" [disabled]="!(filesSelected$ | async)">
          {{ 'core.confirmBtn' | translate }}
        </button>
      </div>
      <mat-list>
        @for (fileItem of uploader.queue; track fileItem) {
          <mat-list-item>
            <div mat-line class="upload-item">
              <mat-checkbox class="vao-checkbox"
                [checked]="fileItem?.file?.name.includes('Vao')"
                name="isVao"
                [id]="slugify(fileItem)"
                labelPosition="before"
                >VAO
              </mat-checkbox>
              <span>{{ fileItem?.file?.name }}</span>
              @if (fileItem.isError) {
                <mat-error>{{ 'core.fileUploadError' | translate }}</mat-error>
              }
              <button mat-icon-button (click)="fileItem.remove()">
                <mat-icon class="material-icons">clear</mat-icon>
              </button>
            </div>
            @if (uploader.queue.length > 0) {
              <div mat-line class="upload-item-progress-bar">
                <mat-progress-bar [value]="fileItem.progress"></mat-progress-bar>
              </div>
            }
          </mat-list-item>
        }
      </mat-list>
    </div>
  </mat-card>
}
